import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import boxMixin, { boxMixinPropsType } from "../../../mixins/box";
export const SkeletonBox = styled(Skeleton).withConfig({
    shouldForwardProp: boxMixinPropsType.shouldForwardProp,
}) `
  ${boxMixin};
  padding: unset !important;
  display: inline-flex !important;
  background-color: var(--base-color) !important;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2tlbGV0b25Cb3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Cb3gvc3R5bGVkL1NrZWxldG9uQm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sUUFBUSxNQUFNLHdCQUF3QixDQUFDO0FBQzlDLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sUUFBUSxFQUFFLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUVsRSxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLFVBQVUsQ0FBQztJQUNyRCxpQkFBaUIsRUFBRSxpQkFBaUIsQ0FBQyxpQkFBaUI7Q0FDdkQsQ0FBQyxDQUFBO0lBQ0UsUUFBUTs7OztDQUlYLENBQUMifQ==